import { store } from '../app/store';
import { getApiGatewayUrl } from './deviceStatusHandler';
const apigClientFactory = require('aws-api-gateway-client').default;

export interface ComponentOnboardingStatus {
    vin: string;
    deviceId: string;
    componentId: string;
    componentType: string;
    status: string;
    lastUpdateTimestampMs?: number;
    installationStartTimestampMs?: number;
    installationEndTimestampMs?: number;
    notes?: string;
    errorMessage?: string;
}

export default (
    deviceId: string,
    componentType: string,
    componentId: string | undefined,
    setResult: (success: boolean, result: ComponentOnboardingStatus | any) => void,
) => {
    // extract endpoint from config
    const client = apigClientFactory.newClient({
        invokeUrl: getApiGatewayUrl(),
        retries: 3,
    });

    const queryParams = {
        deviceId: deviceId,
        componentType: componentType,
        ...(componentId && { componentId: componentId }),
    };

    client
        .invokeApi(
            {},
            '/get_device_component_status',
            'GET',
            {
                queryParams: queryParams,
                headers: {
                    Authorization: store.getState().userData.userInfo!.jwt,
                },
            },
            null,
        )
        .then((response: any) => {
            let parsedData = response.data;
            if (typeof response.data === 'string') {
                const unescapedData = response.data.replace(/\\"/g, '"');
                parsedData = JSON.parse(unescapedData);
            }
            setResult(true, parsedData);
        })
        .catch((response: any) => {
            setResult(false, response);
        });
};
